import React from 'react';
import Main from './Main';
import Navbar from './Navbar';


const App = () => {
  return (
        <div>
          <Navbar />
          <Main />
        </div>
  )
}
export default App